import { Col, Row, Table, Tag } from "antd";
import { MdEdit, MdOpenInNew, MdOutlineDeleteOutline } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { COLORS } from "shared/style/colors";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";

const STATUS_COLORS = {
  draft: "orange",
  confirmed: "green",
};

const View = ({ data, count, setValues, skip, duplicate }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const LIST = t("LIST", { returnObjects: true });
  const navigate = useNavigate();
  const i18nLocale = t("LIST.DATE_LOCALE", { defaultValue: "fr-FR" });

  const columns = [
    {
      title: LIST.NAME,
      dataIndex: "name",
      render: (name) => <Tag>{name}</Tag>,
    },
    {
      title: LIST.STATUS,
      dataIndex: "status",
      render: (status) => (
        <Tag color={STATUS_COLORS[status] || "default"}>{status}</Tag>
      ),
    },
    {
      title: LIST.CREATED_DATE,
      dataIndex: "createdDate",
      render: (date) =>
        date ? new Date(date).toLocaleDateString(i18nLocale) : LIST.NONE,
    },
    {
      title: LIST.ACTIONS,
      dataIndex: "id",
      align: "right",
      render: (id) => (
        <Row gutter={8} justify="end" align="center" wrap={false}>
          <Col
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.DETAIL.path}/${id}`,
              )
            }
          >
            <MdOpenInNew size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.EDIT.path}/${id}`,
              )
            }
          >
            <MdEdit size={24} color={COLORS.C_PRIMARY} />
          </Col>
          <Col
            style={{ cursor: "pointer" }}
            onClick={() =>
              navigate(
                `${SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.DELETE.path}/${id}`,
              )
            }
          >
            <MdOutlineDeleteOutline size={24} color={COLORS.C_DANGER} />
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        className="table__wrapper"
        columns={columns}
        rowKey="id"
        pagination={false}
        scroll={{ x: true }}
      />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
};

export default View;
